export { default as Instagram } from './Instagram';
